/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Directory_Submit_Enrich_Published_NamedInputs */

const en_directory_submit_enrich_published_named = /** @type {(inputs: Directory_Submit_Enrich_Published_NamedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} has been published.`)
};

const zh_directory_submit_enrich_published_named = /** @type {(inputs: Directory_Submit_Enrich_Published_NamedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} 已发布。`)
};

/**
* | output |
* | --- |
* | "{name} has been published." |
*
* @param {Directory_Submit_Enrich_Published_NamedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_enrich_published_named = /** @type {((inputs: Directory_Submit_Enrich_Published_NamedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Enrich_Published_NamedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_enrich_published_named(inputs)
	return zh_directory_submit_enrich_published_named(inputs)
});
export { directory_submit_enrich_published_named as "directory.submit.enrich.published_named" }